/**
 * An empty array.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EmptyArray: ReadonlyArray<any> = [];
